import { render, staticRenderFns } from "./SecondPage.vue?vue&type=template&id=46a09ede&scoped=true"
import script from "./SecondPage.vue?vue&type=script&lang=js"
export * from "./SecondPage.vue?vue&type=script&lang=js"
import style0 from "./SecondPage.vue?vue&type=style&index=0&id=46a09ede&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a09ede",
  null
  
)

export default component.exports